import { PillarsMenu } from '@/models/channels'

const isMenuOpen = state => state.menuState !== PillarsMenu.CLOSED

const isMenuCompact = state => state.menuState === PillarsMenu.COMPACT

const isMenuExpanded = state => state.menuState === PillarsMenu.EXPANDED

export default {
  isMenuOpen,
  isMenuCompact,
  isMenuExpanded
}
